<template>
  <div >
   <router-view :key="$route.fullPath" />
   <div class="px-5">
    <v-row>
      <v-col class="main_title" v-if="$route.name === 'Licences'">
        <v-flex tag="h2" class=" primary-text">
          Licensees
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" dark v-bind="attrs" v-on="on">
                information
              </v-icon>
            </template>
            <span>Licensees</span>
          </v-tooltip> -->
        </v-flex>
        <v-divider class="mt-4" />
      </v-col>
    </v-row>
    <v-row class="no-gutters align-center">
      <v-col md="4"  v-if="$route.name === 'Licences'">
        <v-text-field
          v-model="search"
          label="Search"
          prepend-inner-icon="search"
          class="search-control"
          @keyup="getCustomerInfo(), pageReset()"
        />
      </v-col>
    </v-row>
    <v-row class="custom-simple-table">
      <v-col v-if="$route.name === 'Licences'">
        <v-simple-table>
          <thead>
              <tr>
                <th class="text-left"> Name </th>
                <th class="text-left"> Company </th>
                <th class="text-left"> Tier </th>
                <th class="text-center"> Status </th>
                <th class="text-center"> Action </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in getCustomers.data" :key="index">
                  <td>{{item.name}}</td>
                  <td>{{item.orgName}}</td>
                  <td>{{item.tierName}}</td>
                  <td class="text-center">
                    <v-chip v-if="!item.isExpired&&item.isActive">
                    <v-icon left> mdi-check-circle </v-icon>
                    Active
                   </v-chip>
                   <v-chip v-if="item.isExpired" color="red" class="expiredchip">
                    <span style="color: #fff !important;">Expired</span>
                  </v-chip> 
                    
                  </td>
                  <td class="text-center">
                    <v-btn icon @click="$router.push(`/licences/view-licence/${item.id}`)">
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                  </td>
              </tr>
              <tr v-if="getCustomers.data.length<1">
                <td colspan="5" class="text-center">No data available</td>
              </tr>
            </tbody>
        </v-simple-table>
        <div class="primary-icon">
        <license-pagination :total="getCustomers.total" :value="page" @input="pageEmit" />
      </div>
      </v-col>
    </v-row>
  </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import LicensePagination from '@/components/LicensePagination/licensePagination.vue'
import { storeActions } from '../../store/actions.constants';
import ViewLicence from './viewLicence.vue';
export default {
  components:{
    LicensePagination,
    ViewLicence
},
  data: () => ({
    headers: [
      {
        text: 'Company',
        align: 'start',
        sortable: true,
        value: 'Company',
      },
      { text: 'Tier Name', value: 'tier_name' },
      { text: 'OnBoard Type', value: 'onBoardType' },
      { text: 'Products Included', value: 'Products' },
      { text: 'User Count', value: 'userCount' },
      { text: 'StartDate', value: 'StartDate' },
      { text: 'EndDate', value: 'EndDate' },
      { text: 'Actions', value: 'action', sortable: false },
    ],
    search: '',
    options: {},
    loading: false,
    viewLicence: false,
    page: 1,
    itemsPerPage: 10,
    company: "HBO",
    tierType:2,
    tierTypes: [],
    customerData: [],
    onBoard: ['Self', 'Qentelli'],
    selectedTierType: null,
    selectedOnBoard:null,
    sortDesc:[]
  }),
  computed: {
    ...mapGetters({
      licenses: 'licensees/getLicense',
      getCustomers: 'licensees/getCustomers',
     }),
     tierList() {
      return this.tierTypes.map((tier) => ({
        id: tier.id,
        tierName: tier.tier_name,
      }));
     },
    //  pageCount() {
    //   return Math.ceil(this.licenses.total / this.itemsPerPage)
    //   },
  },
  // watch: {
  //   options: {
  //     async handler() {
  //       if(this.options.page !== undefined)  this.getLicencesList();
  //     },
  //     deep: true,
  //   },
  // },
  async mounted() {
   //if(this.options.page !== undefined)   await this.getLicencesList();
   //let res = await this.getTierDetails();
    //this.tierTypes = res.data;
    if(this.options.page !== undefined)   await this.getCustomerInfo();
    let response = await this.getCustomerInfo();
    this.customerData = response;
    //console.log('jdksd',this.customers);
  },
  methods: {
    ...mapActions({
      getLicense: 'licensees/getLicense',
      getTierDetails: 'licensees/getTierDetails',
      getCustomerList: 'licensees/getCustomerList',
    }),
    pageReset() {
      if(this.search) {
        this.page=1;
      }
    },
    pageEmit(data) {
      if(data>0) this.page=data;
     // this.getLicencesList();
      this.getCustomerInfo();
    },
    resetAll() {
      this.search='';
      this.page=1;
      this.selectedOnBoard=null;
      this.selectedTierType=null;
      this.tierType=null;
      //this.getLicencesList();
    },
    // getLicencesList() {
    //   if(this.selectedTierType) {
    //     this.page=1;
    //   }
    //   this.loading = true;
    //   const { sortBy, sortDesc} = this.options;
    //   // this.$store.dispatch(`users/${storeActions.loginAction}`, usrObj).then((res) => console.log(res))
    //   this.getLicense({
    //     page: this.page,
    //     limit: 10,
    //     search: this.search ||'',
    //     tiertype:this.selectedTierType?this.selectedTierType.join(','):'',
    //     onboardType:this.selectedOnBoard||'',
    //     sort:sortBy[0],
    //     desc:this.sortDesc[0] ||0,
    //   })
    //     .then((res) => {
    //       if (res.status === 200) {
    //         let items = res.data.data;
    //         //const total = items.length;
    //         this.loading = false;
    //       }
    //     })
    //     .catch((err) => {
    //       this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
    //         text: err.response.data.message,
    //         timeout: 3000,
    //         color: 'error',
    //       });
    //     });
    // },
      getCustomerInfo() {
      // const { sortBy } = this.options;
      // this.loading = true;
      // const { sortBy, sortDesc} = this.options;
      // this.$store.dispatch(`users/${storeActions.loginAction}`, usrObj).then((res) => console.log(res))
      this.getCustomerList({
        page: this.page,
        limit: 10,
        search: this.search.trim() || '',
        // products: this.selectedTierType ? this.selectedTierType.join(',') : '',
        // onboardType:this.selectedOnBoard||'',
        // sort: sortBy[0],
        // desc: this.sortDesc[0] || 0,
      })
        .then((res) => {
          if (res.status === 200) {
            let items = res.data.data;
            //console.log('Items',items)
            const total = items.length;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
        });
    },
    moment: function(value) {
      return moment(value).format('DD/MM/YYYY');
    },

    // openDeleteLicense(item){

    // },
    // editSelectedItem(){
    //    this.getLicense()
    //     .then((res) => {
    //
    //       if (res.status === 200) {
    //         console.log(res)
    //       }
    //     })
    //     .catch((err) => {
    //       // Skip login until API and schema got finalise
    //       console.error(err);
    //     });
    // },
    // deleteSelectedItem(){
    //    this.getLicense()
    //     .then((res) => {
    //
    //       if (res.status === 200) {
    //         console.log(res)
    //       }
    //     })
    //     .catch((err) => {
    //       // Skip login until API and schema got finalise
    //       console.error(err);
    //     });
    // },
  },
};
</script>
